import React from "react";
import { withTranslation } from "react-i18next";
import ScannerBuyContent from "./ScannerBuyContent";
import { getPaymentPlans, PRODUCT_NAMES } from "API/StripeAPI";

class ScannerApiBuyPlans extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      monthlyPlans: [],
      payAsYouGoPlans: []
    };
    this.init();
  }

  async init() {
    const monthlyPlans = await getPaymentPlans(PRODUCT_NAMES.URL_CHECKER_MONTHLY);
    const payAsYouGoPlans = await getPaymentPlans(PRODUCT_NAMES.URL_CHECKER_PAY_AS_YOU_GO);

    monthlyPlans.sort((a, b) => a.priceInCents - b.priceInCents);
    payAsYouGoPlans.sort((a, b) => a.priceInCents - b.priceInCents);

    this.setState({ 
      monthlyPlans: monthlyPlans,
      payAsYouGoPlans: payAsYouGoPlans
     });
  }

  render() {
    const { t, i18n } = this.props;
    return (
      <div
        className="d-flex flex-column flex-sm-row w-100"
        style={{ gap: "1rem" }}
      >
        <div className="flex-fill">
          <ScannerBuyContent
            title={t("phish_guard_url_checker.buy.monthly")}
            subTitle={t("phish_guard_url_checker.buy.monthly_subtitle")}
            product={t("phish_guard_url_checker.buy.monthly_product")}
            tooltip={t("phish_guard_url_checker.buy.monthly_tooltip")}
            buyText={t("phish_guard_url_checker.buy.buy_text")}
            optionsList={this.state.monthlyPlans}
            mostPopular={t("phish_guard_url_checker.buy.most_popular")}
          />
        </div>
        <div className="flex-fill">
          <ScannerBuyContent
            title={t("phish_guard_url_checker.buy.pay_as_you_go")}
            subTitle={t("phish_guard_url_checker.buy.pay_as_you_go_subtitle")}
            product={t("phish_guard_url_checker.buy.pay_as_you_go_product")}
            tooltip={t("phish_guard_url_checker.buy.pay_as_you_go_tooltip")}
            buyText={t("phish_guard_url_checker.buy.buy_text")}
            optionsList={this.state.payAsYouGoPlans}
          />
        </div>
      </div>
    );
  }
}

export default withTranslation()(ScannerApiBuyPlans);
